export default "__VITE_ASSET__CUOVjOCM__"